//新建ANS
import request from '../../utils/request'
import { UrlSearch } from "../../utils/UrlSearch";
const shopTitle = UrlSearch().shop;
let shopName ;
if(shopTitle){
  let index = shopTitle.indexOf('.');
  if(index>0){
      shopName = shopTitle.substring(0,index);
  }else{
      shopName = shopTitle;
  }

}
console.log(shopName)
//获取ans榆树方式
export function asnshipping() {
  let param={}
  param.shopName = shopName;
  return request({
    url: `get-asn-shipping-method`,
    method: 'post',
    params: param
  })
}
//ans单列表
export function getasnlist(param) {
    param.shopName = shopName
  return request({
    url: `get-asn-list`,
    method: 'post',
    params: param
  })
}

export function getspecial() {
  let param={}
  param.shopName = shopName;
  return request({
    url: `get-special-project-option`,
    method: 'post',
    params: param
  })
}

export function getasnstatuscount() {
  let param={}
  param.shopName = shopName;
  return request({
    url: `get-asn-status-count`,
    method: 'post',
    params: param
  })
}


export function createasn(param) {
    param.shopName = shopName
  return request({
    url: `create-asn`,
    method: 'post',
    params: param
  })
}


//ans详情
export function getasndetail(param) {
    param.shopName = shopName
  return request({
    url: `get-asn-detail`,
    method: 'post',
    params: param
  })
}
export function editreceivingitem(param) {
    param.shopName = shopName
  return request({
    url: `edit-receiving-item`,
    method: 'post',
    params: param
  })
}



//ans日志
export function getasnlog(param) {
    param.shopName = shopName
  return request({
    url: `get-asn-log`,
    method: 'post',
    params: param
  })
}

//ans补运单号码
export function updatetracking(param) {
    param.shopName = shopName
  return request({
    url: `update-asn-tracking-inf`,
    method: 'post',
    params: param
  })
}

//删除ans单
export function updateasnstatus(param) {
    param.shopName = shopName
  return request({
    url: `update-asn-status`,
    method: 'post',
    params: param
  })
}













// WEBPACK FOOTER //
// ./src/components/views/api/ans.js